import React from 'react';
import TrimContext from '../VideoTrimContex';

export default function VideoTrimmingProvider(props) {
  const { children } = props;
  return <TrimContext.Provider>{children}</TrimContext.Provider>;
}
